import { Icon, IconProps } from '@chakra-ui/react'
import React from 'react'

const BlackCartIcon = ({ ...rest }: IconProps) => {
  return (
    <Icon
      width="20px"
      height="25px"
      viewBox="0 0 20 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect y="5" width="20" height="20" rx="2" fill="black" />
      <path
        d="M3 5C3 1.13401 6.13401 -2 10 -2C13.866 -2 17 1.13401 17 5H13C13 3.34315 11.6569 2 10 2C8.34315 2 7 3.34315 7 5H3ZM15 5H5H15ZM3 5C3 1.13401 6.13401 -2 10 -2V2C8.34315 2 7 3.34315 7 5H3ZM10 -2C13.866 -2 17 1.13401 17 5H13C13 3.34315 11.6569 2 10 2V-2Z"
        fill="black"
        mask="url(#path-2-inside-1_8822_32858)"
      />
    </Icon>
  )
}

export default BlackCartIcon
